import { I18n } from "@assets/strings";
import React from "react";
import { allAreaExpertise, AreaExpertise } from "@domain/userKyc/areaExpertise";
import { Selecter } from "./selecter";

interface AreaExpertiseSelectorProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	value: "" | AreaExpertise;
	onChange: (value: AreaExpertise) => void;
}

export const AreaExpertiseSelector: React.FC<AreaExpertiseSelectorProps> = ({ value, onChange, ...htmlProps }) => {
	return (
		<Selecter
			options={allAreaExpertise.map((item) => ({ label: I18n.t(`expertise.${item}`), value: item }))}
			{...htmlProps}
			value={value}
			onChange={(value) => onChange(value as AreaExpertise)}
		/>
	);
};
